import React, { useState } from 'react';
import '../../styles/sections/FAQ.css';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: "How long does shipping take?",
      answer: "Standard shipping: 5-7 days\nExpress shipping: 2-4 days"
    },
    {
      question: "What type of images can I upload?",
      answer: "We accept PNG and JPG files up to 5MB in size. For best results, use high-resolution photos."
    },
    {
      question: "What size are the tiles?",
      answer: "Our tiles are 100mm x 100mm (approximately 4 inches square), perfect for displaying on a desk or shelf."
    },
    {
      question: "How are the images printed?",
      answer: "We use a specialized ceramic printing process that ensures your image is permanently bonded to the tile surface, making it durable and fade-resistant."
    },
    {
      question: "Can I order multiple tiles?",
      answer: "Currently, we process one tile per order. Multiple tile orders will be available soon!"
    },
    {
      question: "Do you ship internationally?",
      answer: "At this time, we only ship within Australia to ensure the best quality service and reasonable delivery times."
    },
    {
      question: "How should I care for my printed tile?",
      answer: "Your tile is durable and water-resistant. Clean with a soft, damp cloth. Avoid harsh cleaning chemicals or abrasive materials."
    },
    {
      question: "Do you offer refunds?",
      answer: "Due to the custom nature of our products, we don't offer refunds. However, if your tile arrives damaged, we'll replace it free of charge. Simply contact us within 7 days of delivery with photos of the damage."
    },
    {
      question: "What happens to my uploaded photos?",
      answer: "Your privacy is important to us. Uploaded images are stored securely and automatically deleted after 3 months. They are never shared or used for any other purpose."
    },
    {
      question: "How do I track my order?",
      answer: "Once your order ships, you'll receive a tracking number via email. You can use this to monitor your delivery progress."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq">
      <div className="faq-content">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqItems.map((item, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{item.question}</h3>
                <span className="faq-icon">+</span>
              </div>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ; 